var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36641 3.19499C5.59113 2.26823 6.90919 2.26823 7.13392 3.19499L7.75227 5.74503C7.8325 6.07591 8.09084 6.33425 8.42172 6.41448L10.9718 7.03283C11.8985 7.25756 11.8985 8.57562 10.9718 8.80034L8.42172 9.41869C8.09084 9.49892 7.8325 9.75727 7.75227 10.0881L7.13392 12.6382C6.90919 13.5649 5.59113 13.5649 5.36641 12.6382L4.74806 10.0881C4.66783 9.75727 4.40948 9.49892 4.0786 9.41869L1.52857 8.80034C0.601807 8.57562 0.601806 7.25756 1.52856 7.03283L4.0786 6.41448C4.40948 6.33425 4.66783 6.07591 4.74806 5.74503L5.36641 3.19499Z",
    fill: "url(#paint0_linear_67_22125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7896 12.0943C12.9279 11.524 13.7391 11.524 13.8773 12.0943L14.2579 13.6636C14.3072 13.8672 14.4662 14.0262 14.6698 14.0755L16.2391 14.4561C16.8094 14.5944 16.8094 15.4055 16.2391 15.5438L14.6698 15.9243C14.4662 15.9737 14.3072 16.1326 14.2579 16.3363L13.8773 17.9055C13.7391 18.4758 12.9279 18.4758 12.7896 17.9055L12.4091 16.3363C12.3598 16.1326 12.2008 15.9737 11.9972 15.9243L10.4279 15.5438C9.85758 15.4055 9.85758 14.5944 10.4279 14.4561L11.9972 14.0755C12.2008 14.0262 12.3598 13.8672 12.4091 13.6636L12.7896 12.0943Z",
    fill: "url(#paint1_linear_67_22125)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4766 3.09312C15.5673 2.71885 16.0996 2.71885 16.1904 3.09312L16.4401 4.12294C16.4725 4.25657 16.5768 4.3609 16.7105 4.3933L17.7403 4.64302C18.1146 4.73377 18.1146 5.26607 17.7403 5.35682L16.7105 5.60654C16.5768 5.63894 16.4725 5.74327 16.4401 5.87689L16.1904 6.90672C16.0996 7.28099 15.5673 7.28099 15.4766 6.90672L15.2269 5.87689C15.1945 5.74327 15.0901 5.63894 14.9565 5.60654L13.9267 5.35682C13.5524 5.26607 13.5524 4.73377 13.9267 4.64302L14.9565 4.3933C15.0901 4.3609 15.1945 4.25657 15.2269 4.12294L15.4766 3.09312Z",
    fill: "url(#paint2_linear_67_22125)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8335 3.27583L15.6297 4.11635C15.5482 4.45232 15.2859 4.71464 14.9499 4.79611L14.1094 4.99992L14.9499 5.20373C15.2859 5.2852 15.5482 5.54752 15.6297 5.88349L15.8335 6.72401L16.0373 5.88349C16.1188 5.54752 16.3811 5.2852 16.7171 5.20373L17.5576 4.99992L16.7171 4.79611C16.3811 4.71464 16.1188 4.45232 16.0373 4.11635L15.8335 3.27583ZM16.2414 2.82072C16.1377 2.39298 15.5293 2.39299 15.4256 2.82072L15.1402 3.99766C15.1032 4.15037 14.984 4.26961 14.8312 4.30664L13.6543 4.59203C13.2266 4.69575 13.2266 5.30409 13.6543 5.40781L14.8312 5.6932C14.984 5.73023 15.1032 5.84946 15.1402 6.00218L15.4256 7.17912C15.5293 7.60685 16.1377 7.60685 16.2414 7.17912L16.5268 6.00218C16.5638 5.84946 16.683 5.73023 16.8358 5.6932L18.0127 5.40781C18.4404 5.30409 18.4404 4.69575 18.0127 4.59203L16.8358 4.30664C16.683 4.26961 16.5638 4.15037 16.5268 3.99766L16.2414 2.82072Z",
    fill: "url(#paint3_linear_67_22125)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 19.1666C5.37326 19.1666 5.00016 18.7935 5.00016 18.3333C5.00016 17.873 5.37326 17.4999 5.8335 17.4999C6.29373 17.4999 6.66683 17.873 6.66683 18.3333C6.66683 18.7935 6.29373 19.1666 5.8335 19.1666Z",
    fill: "url(#paint4_linear_67_22125)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66683 15.8333C1.20659 15.8333 0.833496 15.4602 0.833496 14.9999C0.833496 14.5397 1.20659 14.1666 1.66683 14.1666C2.12707 14.1666 2.50016 14.5397 2.50016 14.9999C2.50016 15.4602 2.12707 15.8333 1.66683 15.8333Z",
    fill: "url(#paint5_linear_67_22125)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 2.49992C10.3733 2.49992 10.0002 2.12682 10.0002 1.66659C10.0002 1.20635 10.3733 0.833252 10.8335 0.833252C11.2937 0.833252 11.6668 1.20635 11.6668 1.66659C11.6668 2.12682 11.2937 2.49992 10.8335 2.49992Z",
    fill: "url(#paint6_linear_67_22125)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 11.6666C17.8733 11.6666 17.5002 11.2935 17.5002 10.8333C17.5002 10.373 17.8733 9.99992 18.3335 9.99992C18.7937 9.99992 19.1668 10.373 19.1668 10.8333C19.1668 11.2935 18.7937 11.6666 18.3335 11.6666Z",
    fill: "url(#paint7_linear_67_22125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_67_22125",
    x1: -1.59297,
    y1: 3.69784,
    x2: 19.3364,
    y2: 4.32318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F553DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#CB59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#6541F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3385FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_67_22125",
    x1: -1.59297,
    y1: 3.69784,
    x2: 19.3364,
    y2: 4.32318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F553DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#CB59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#6541F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3385FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_67_22125",
    x1: -1.59297,
    y1: 3.69784,
    x2: 19.3364,
    y2: 4.32318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F553DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#CB59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#6541F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3385FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_67_22125",
    x1: -1.59297,
    y1: 3.69784,
    x2: 19.3364,
    y2: 4.32318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F553DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#CB59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#6541F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3385FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_67_22125",
    x1: -1.59297,
    y1: 3.69784,
    x2: 19.3364,
    y2: 4.32318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F553DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#CB59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#6541F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3385FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_67_22125",
    x1: -1.59297,
    y1: 3.69784,
    x2: 19.3364,
    y2: 4.32318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F553DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#CB59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#6541F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3385FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_67_22125",
    x1: -1.59297,
    y1: 3.69784,
    x2: 19.3364,
    y2: 4.32318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F553DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#CB59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#6541F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3385FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_67_22125",
    x1: -1.59297,
    y1: 3.69784,
    x2: 19.3364,
    y2: 4.32318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#F553DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346154,
    stopColor: "#CB59FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#6541F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3385FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGenerate);
export default __webpack_public_path__ + "static/media/icon_generate.fc323d981276d9952db7b5162a449447.svg";
export { ForwardRef as ReactComponent };